import { useQuery } from 'react-query';

import { getFragnetCompletion as queryFn } from 'api/endPoints/getFragnetCompletion';
import { IVersion } from 'api/queries/getProjectVersionsList.query';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetFragnetCompletion = (params: QueryParams) => {
    return useQuery<CompletionPlanSegmentResponse[], QueryError, CompletionPlanSegmentResponse[], [QueryKeys, unknown]>(
        {
            queryKey: ['getFragnetCompletion', params],
            queryFn: () => queryFn(params),
            enabled: Boolean(params.metaDataId),
        },
    );
};

export interface QueryParams {
    metaDataId?: IVersion['id'];
}

export interface CompletionPlanSegmentResponse {
    name: string;
    label: string;
}
